<script setup lang="ts">
import TableFooterBar from '@/components/bars/TableFooterBar.vue';
import KBtn from '@/components/btns/KBtn.vue';
import TablePageFooter from '@/components/footers/TablePageFooter.vue';
import ExportAsCsvIconBtn from '@/components/iconBtns/ExportAsCsvIconBtn.vue';
import SpreadsheetAttachmentsSearchForm from '@/components/searchForms/SpreadsheetAttachmentsSearchForm.vue';
import SpreadsheetTable from '@/components/tables/SpreadsheetTable.vue';
import FormWrapper from '@/components/wrappers/FormWrapper.vue';
import PageContentWrapper from '@/components/wrappers/PageContentWrapper.vue';
import TablePageShadowWrapper from '@/components/wrappers/TablePageShadowWrapper.vue';
import useSpreadsheetJobBookingViewData from '@/composables/data/useSpreadsheetJobBookingViewData';
import { useSpreadsheetJobBookingViewStore } from '@/stores/useSpreadsheetJobBookingViewStore';
import * as routeNames from '@/constants/routeNames';

const spreadsheetJobBookingViewStore = useSpreadsheetJobBookingViewStore();
spreadsheetJobBookingViewStore.init(useSpreadsheetJobBookingViewData());
</script>

<template>
  <div
    :class="$style.spreadsheetJobBookingView"
    data-testid="spreadsheetJobBookingView"
  >
    <PageContentWrapper>
      <h2 class="g-h2">Order a job via spreadsheet upload</h2>
      <FormWrapper :class="$style.formWrapper">
        <div :class="$style.columns">
          <div :class="$style.left">
            <p class="mt-0">
              On this page, you can book jobs using the SpreadSheet template
              file.
              <br />
              Please download it by the link below. Edit the file and upload it
              back to our system.
              <br />
              In case of any error messages, please, fix them in a file and
              upload it again.
            </p>
            <p class="mb-0">
              <a
                href="https://kraken.kkts.com.au/static/KKTS-Bulk-Import-Template.xls"
              >
                Download template
              </a>
            </p>
          </div>
          <div :class="$style.right">
            <SpreadsheetAttachmentsSearchForm
              :initial-data="spreadsheetJobBookingViewStore.initialData"
              :loading="
                spreadsheetJobBookingViewStore.data
                  .isFetchingSpreadsheetJobBookingData
              "
              @submit="spreadsheetJobBookingViewStore.search"
            />
            <small
              v-if="
                spreadsheetJobBookingViewStore.data
                  .spreadsheetJobBookingDataError
              "
              :class="$style.errors"
            >
              <p>Jobs validation failed.</p>
              <ul>
                <li
                  v-for="(job, index) in spreadsheetJobBookingViewStore.data
                    .spreadsheetJobBookingDataError.failed"
                  :key="index + job.error_reason"
                >
                  Error: {{ job.error_reason }}
                </li>
              </ul>
              <p>Please fix the errors and try to upload the file again.</p>
            </small>
          </div>
        </div>
      </FormWrapper>
      <TablePageShadowWrapper :class="$style.tablePageShadowWrapper">
        <SpreadsheetTable
          :data="spreadsheetJobBookingViewStore.spreadsheetJobBookingTableData"
          :loading="
            spreadsheetJobBookingViewStore.data
              .isFetchingSpreadsheetJobBookingData
          "
        />
        <TablePageFooter
          v-if="
            spreadsheetJobBookingViewStore.data.spreadsheetJobBookingData
              ?.booked
          "
          :total="
            spreadsheetJobBookingViewStore.data.spreadsheetJobBookingData
              ?.booked.length
          "
          no-pages
        >
          <ExportAsCsvIconBtn
            :disabled="
              spreadsheetJobBookingViewStore.data
                .isFetchingSpreadsheetJobBookingData ||
              !spreadsheetJobBookingViewStore.data.spreadsheetJobBookingData
                ?.booked.length
            "
            :loading="spreadsheetJobBookingViewStore.isDownloadingCSV"
            @click="spreadsheetJobBookingViewStore.downloadCSV"
          />
        </TablePageFooter>
      </TablePageShadowWrapper>
    </PageContentWrapper>
    <TableFooterBar>
      <KBtn
        size="lg"
        append-icon="mdi-feature-search-outline"
        :disabled="!spreadsheetJobBookingViewStore.jobIds.length"
        :to="{
          name: routeNames.SEARCH_JOB_ID,
          query: {
            job_ids: spreadsheetJobBookingViewStore.jobIds.join(','),
          },
        }"
      >
        Search results
      </KBtn>
    </TableFooterBar>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.spreadsheetJobBookingView {
}
  .formWrapper {
    padding: 2.4rem 1.5rem 0.5rem 1.5rem;
    max-width: calc(100vw - variables.$sideMainBarWidth - (variables.$pageMarginX * 2));
    margin: 2rem 0;
  }
  .tablePageShadowWrapper {
    max-width: calc(100vw - variables.$sideMainBarWidth - (variables.$pageMarginX * 2));
  }
    .columns {
      display: flex;
    }
      .left {
        margin-right: 1.5rem;
        padding-bottom: 1.9rem;
      }
      .right {
      }

  .errors {
    color: colors.$color-status-error-text;
  }
</style>
